import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { modalController } from '@ionic/vue';
import SelectionModal from '@/views/form/SelectionModal.vue';
import { useCart } from '@/stores/cart';
import { computed } from 'vue';
import CustomButton from '@/components/CustomButton.vue';
import FormPart from '@/components/FormPart.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormVoiceSelector',
  setup(__props) {

const cart = useCart();

const openModal = async () => {
  const modal = await modalController.create({
    component: SelectionModal,
  });

  await modal.present();

  const { data, role } = await modal.onWillDismiss();

  if (role === 'confirm') {
    await cart.commitVoice(data);
  }
};

const buttonText = computed(() => (cart.voice?.name ? `Selected [${cart.voice?.name}]` : 'Click Here to Select your Voice'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FormPart, { step: "1" }, {
    default: _withCtx(() => [
      _createVNode(CustomButton, {
        expand: "block",
        onClick: openModal,
        fill: "solid"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})